import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly document = inject(DOCUMENT);

  constructor() {
    const root = this.document.documentElement;
    root.classList.add('dark');
    root.style.colorScheme = 'dark';
  }
}
